export enum FeatureEnum {
    TradingPlans = 'crm.tradingPlans',
    CloseoutPlans = 'alaric-crm.closeout-plans',
    BatchAccountCreation = 'crm.batch-account-creation',

    /**
     * Bond Coupon Payments (FP-1722). Deliberately carries the fund-orders prefix rather than
     * crm. or cross.: it is the same switch as the one alaric-fund-orders reads, named once so
     * the two halves of the feature are obviously the same thing. They are separate systems -
     * this one is a Flagsmith flag, the backend reads the Alaric Flags service - so the name
     * matching is the only thing tying them together, and both have to be turned on.
     */
    BondCouponPayments = 'fund-orders.bond-coupon-payments',
    PublicTraders = 'crm.public_traders',

    /** Hard buying power (CRM-5445): the Flagsmith half of the backend's Alaric Flags key of the same name, so both must be on. */
    HardBuyingPower = 'cross.hard-buying-power',

    /**
     * ACE referral program (ACE-832). Cross-prefixed on purpose: it is the same
     * switch as the backend release gate in alaric-flags (alaric-compliance
     * `cross.ace_referral_program`), named once so the two halves of the feature
     * are obviously the same thing. The CRM operator UI must additionally be
     * visible on the ACE tenant only — that scoping lives in the Flagsmith
     * segment override, not in the name.
     */
    ReferralProgram = 'cross.ace_referral_program',
    
    /**
     * Account onboarding (CRM-5443): Add Account opens the bulk user and account creation wizard instead of the single
     * account pages. The Flagsmith half of the backend's `compliance.account-onboarding`, so both must be on: with the
     * backend off its endpoints answer 404.
     */
    AccountOnboarding = 'crm.account-onboarding',
}